module.exports = __webpack_public_path__ + "static/media/CeraPro-Black.4bf5397f.woff";